/** Build next invoice reference from billing prefix and existing payments. */
export function generateInvoiceReference(billing = {}, existingPayments = []) {
  const prefix = (billing.invoicePrefix || 'FAC').replace(/[^A-Za-z0-9_-]/g, '') || 'FAC';
  const year = new Date().getFullYear();
  const pattern = new RegExp(`^${prefix}-${year}-(\\d+)$`, 'i');
  let maxSeq = 0;

  for (const payment of existingPayments) {
    const ref = payment?.reference || payment?.invoiceNumber || '';
    const match = String(ref).match(pattern);
    if (match) {
      maxSeq = Math.max(maxSeq, parseInt(match[1], 10));
    }
  }

  return `${prefix}-${year}-${String(maxSeq + 1).padStart(3, '0')}`;
}

export function resolveBillingSettings(orgSettings) {
  const billing = orgSettings?.billing || {};
  return {
    taxRate: billing.taxRate != null ? Number(billing.taxRate) : 19,
    invoicePrefix: billing.invoicePrefix || 'FAC',
    paymentTerms: billing.paymentTerms != null ? Number(billing.paymentTerms) : 30,
    lateFee: billing.lateFee != null ? Number(billing.lateFee) : 0,
  };
}

/** dueDate = paymentDate + paymentTerms days (0 = same day). Returns YYYY-MM-DD. */
export function computeDueDate(paymentDate, paymentTermsDays = 30) {
  if (!paymentDate) return '';
  const base = new Date(paymentDate);
  if (Number.isNaN(base.getTime())) return '';
  const days = Number(paymentTermsDays);
  if (days === 0) return base.toISOString().split('T')[0];
  const due = new Date(base);
  due.setDate(due.getDate() + days);
  return due.toISOString().split('T')[0];
}

export function getPaymentRemaining(payment) {
  if (!payment) return 0;
  const total = parseFloat(payment.totalAmount) ?? parseFloat(payment.amount) ?? 0;
  const paid = parseFloat(payment.paidAmount) ?? parseFloat(payment.amount) ?? 0;
  return Math.max(0, total - paid);
}

export function isPaymentOverdue(payment) {
  if (!payment || payment.isPaid) return false;
  if (getPaymentRemaining(payment) <= 0) return false;
  const dueDate = payment.dueDate;
  if (!dueDate) return false;
  const due = new Date(dueDate);
  if (Number.isNaN(due.getTime())) return false;
  due.setHours(23, 59, 59, 999);
  return due < new Date();
}
